import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../../api/cafeApi';
import { TDS } from '../../constants/tds';
import { TdsButton } from '../../components/tds';

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError('아이디와 비밀번호를 입력해 주세요');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await adminLogin(username.trim(), password);
      sessionStorage.setItem('admin_token', result.token);
      navigate('/admin/dashboard', { replace: true });
    } catch {
      setError('로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        backgroundColor: TDS.color.bgPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 24px',
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: TDS.radius.xl,
          backgroundColor: TDS.color.gray100,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '36px',
          marginBottom: 20,
        }}
      >
        🔐
      </div>

      <h1 style={{ ...TDS.typography.h2, color: TDS.color.textPrimary, marginBottom: 8 }}>
        관리자 로그인
      </h1>
      <p style={{ ...TDS.typography.body3, color: TDS.color.textTertiary, marginBottom: 32 }}>
        관리자 계정으로 로그인하세요
      </p>

      <form
        onSubmit={(e) => void handleSubmit(e)}
        style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 320, width: '100%' }}
      >
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="아이디"
          autoComplete="off"
          style={{
            width: '100%',
            padding: '14px 16px',
            ...TDS.typography.body2,
            borderRadius: TDS.radius.md,
            border: `1.5px solid ${TDS.color.gray200}`,
            outline: 'none',
            fontFamily: 'inherit',
            color: TDS.color.textPrimary,
            backgroundColor: TDS.color.gray50,
          }}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="비밀번호"
          style={{
            width: '100%',
            padding: '14px 16px',
            ...TDS.typography.body2,
            borderRadius: TDS.radius.md,
            border: `1.5px solid ${TDS.color.gray200}`,
            outline: 'none',
            fontFamily: 'inherit',
            color: TDS.color.textPrimary,
            backgroundColor: TDS.color.gray50,
          }}
        />

        {error && (
          <p style={{ ...TDS.typography.caption1, color: TDS.color.red }}>
            {error}
          </p>
        )}

        <TdsButton type="submit" variant="primary" size="lg" fullWidth loading={loading} style={{ marginTop: 4 }}>
          로그인
        </TdsButton>
      </form>
    </div>
  );
}
